import React from 'react'
import request from 'superagent'
import FormInput from './FormInput'
import FormTextArea from './FormTextArea'

export default class ContactPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      email: '',
      tel: '',
      inquiry: '',
      date: '',
      allok: false,
      shouldShowDate: false
    }
    this.oks = {date: false}
  }
  handleChange (e) {
    // すべての項目がOKになったか?
    this.oks[e.name] = e.isOK
    const isDateOk = this.state.shouldShowDate ? this.oks['date'] : true
    const isAllOk = this.oks['name'] && (this.oks['email'] || this.oks['tel']) && this.oks['inquiry'] && isDateOk
    this.setState({
      [e.name]: e.value,
      allok: isAllOk
    })
  }
  handleChangeType (e) {
    const shouldShowDate = e.target.value === 'meeting'
    const isDateOk = shouldShowDate ? this.oks['date'] : true
    const isAllOk = this.oks['name'] && this.oks['email'] && this.oks['inquiry'] && isDateOk
    this.setState({
      allok: isAllOk,
      shouldShowDate: shouldShowDate
    })
  }
  handleSubmit (e) {
    const content = JSON.stringify(this.state)
    request
      .get('https://sharehouse-116bb.appspot.com/api/sendMail')
      .query({'content': content})
      .end((err, res) => {
        if (err) {
          console.error(err)
          window.alert('メール送信に失敗しました。恐れ入りますが、再度[送信]ボタン押下をお試しください')
        } else {
          this.props.history.push('/contactComplete')
        }
      })
    e.preventDefault()
  }
  renderStatusMessage () {
    const so = {
      display: 'inline-block',
      margin: '10px auto'
    }
    let msg = null
    if (this.state.allok) {
      // OKのとき
      so.color = 'green'
      msg = <label style={so}>ご入力ありがとうございます。[送信]ボタン押下で完了します。<br/>確認画面はありませんので、ご注意ください。</label>
    } else {
      // NGのとき
      let errorName = null
      let errorEmail = null
      let errorInquiry = null
      let errorDate = null
      if (this.oks['name'] !== true) {
        errorName = <span><i className="fas fa-user"></i>お名前 </span>
      }
      if (this.oks['email'] !== true) {
        errorEmail = <span><i className="far fa-envelope"></i>メールアドレス </span>
      }
      if (this.state.shouldShowDate && this.oks['date'] !== true) {
        errorDate = <span><i className="fas fa-calendar-day"></i>面談希望日 </span>
      }
      if (this.oks['inquiry'] !== true) {
        errorInquiry = <span><i className="fas fa-comment"></i>お問い合わせ内容 </span>
      }
      const errorInputs = (<div>{errorName}{errorEmail}{errorDate}{errorInquiry}をご記入ください。</div>)
      so.color = 'red'
      msg = <label style={so}>{errorInputs}</label>
    }
    return msg
  }
  renderCalendarMessage () {
    let msg = null
    if (this.state.shouldShowDate) {
      const doChange = e => this.handleChange(e)
      // 日付を表すパターン
      const datePat = /^([0-9]{4}-?[0-9]{2}-?[0-9]{2})$/
      msg =
        <FormInput name='date'
          label='面談希望日'
          type='date'
          value={this.state.date}
          pattern={datePat}
          onChange={doChange} />
    }
    return msg
  }
  render () {
    const doChange = e => this.handleChange(e)
    const doChangeType = e => this.handleChangeType(e)
    const doSubmit = e => this.handleSubmit(e)
    // Eメールを表すパターン
    const emailPat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    // TELを表すパターン
    const telPat = /^([0-9]{3}-?[0-9]{4}-?[0-9]{4})$/
    // ASCII文字以外全部
    const asciiFilter = /[^\u0020-\u007e]+/g
    let msg = this.renderStatusMessage()
    let calendarMsg = this.renderCalendarMessage()
    return (
      <div className='contact'>
        <h2>お問い合わせ</h2>
        <ul className="breadcrumb">
          <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
            <a href="/" itemProp="url">
              <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
            </a>
          </li>
          <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
            <span itemProp="title"> <i className="fas fa-caret-right"></i> お問い合わせ</span>
          </li>
        </ul>
        <form className='contact-form' onSubmit={doSubmit}>
          {msg}<br />
          <a href="mailto:kojiwatan717@gmail.com">こちら</a>からでもメール可能です。<a href="tel:090-5449-5051">090-5449-5051</a>へのお電話もお待ち申し上げます。<br />なお、Google Meetによるオンライン内覧も承りますので、ご相談ください。<br />
          <br />
          <div>
            <label className='contact-form-title'><i className="fas fa-question-circle"></i> お問い合わせの種類</label><br />
            <select onChange={doChangeType}>
              <option value='inquiry' key='1'>お問い合わせ</option>
              <option value='meeting' key='2'>面談予約</option>
            </select>
          </div>
          <FormInput name='name'
            label='お名前'
            type='text'
            value={this.state.name}
            placeholder='山田花子'
            pattern={/^.+$/}
            onChange={doChange} />
          <FormInput name='email'
            label='メールアドレス'
            type='email'
            value={this.state.email}
            placeholder='hanako@gmail.com'
            filter={asciiFilter}
            pattern={emailPat}
            onChange={doChange} />
          <FormInput name='tel'
            label='電話番号(任意)'
            type='tel'
            value={this.state.tel}
            placeholder='090-1234-5678'
            filter={/[^0-9-()+]/g}
            pattern={telPat}
            onChange={doChange} />
          {calendarMsg}
          <FormTextArea name='inquiry'
            label='お問い合わせ内容'
            type='text'
            value={this.state.inquiry}
            placeholder='お問い合わせ等の内容をこちらにご記入ください。'
            pattern={/^.+$/}
            onChange={doChange} />
          <input type='submit' value='送信' disabled={!this.state.allok} />
        </form>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/ContactPage.js